import styled from "styled-components";

const ItemList = styled.div`
  height: 100%;
  position: relative;
`;

export default ItemList;
